const Roles = {
  Admin: "PartnerPortalAdmin",
  User: "PartnerPortalUser",
  ContactManager: "SupportContactManager",
  Skyward: "SkywardStaff",
  Vendor: "Vendor",
  Support: "Support",
  Documentation: "Documentation",
};

export const ExcludeRoles: Function = (excludedRoles: string[]) => {
  let roleList: string[] = [];
  let role: keyof typeof Roles;
  for (role in Roles) {
    if (!excludedRoles.includes(Roles[role])) {
      roleList.push(Roles[role]);
    }
  }
  return roleList;
};

export default Roles;
